
function toSSAGQueryParams(queryParams) {
	if (!queryParams || queryParams.order === undefined) {
		return queryParams;
	}
	const { order, ...rest } = queryParams;
	return { ...rest, sort: order };
}

module.exports = toSSAGQueryParams;
